import Toaster from "../utils/classes/Toaster";

export default function(el) {
    const message = el.dataset.message;

    if (!message) return;

    const toast = Toaster.createToast("translation-warning", message, "\u2139", true);
    Toaster.renderToast(toast, 1000);
}
